/**
 * Brand Logo for Eco Ready Solutions, LLC
 *  - Bright green badge background (matches flyer/business-card mark)
 *  - Custom icon (green plant atop blue squiggle) supplied by client
 *  - "Eco Ready" bold white wordmark
 *  - "SOLUTIONS, LLC" letter-spaced beneath
 */
export default function Logo({ size = 56, className = "", showWordmark = true }) {
  const h = size;
  const eco = Math.round(h * 0.34);
  const sol = Math.round(h * 0.16);
  const padX = Math.round(h * 0.34);
  // bg color matches the source icon's native background so it blends seamlessly
  const bg = "#61CC94";
  return (
    <span
      className={`inline-flex items-center rounded-[10px] ${className}`}
      style={{ background: bg, height: h, paddingLeft: padX, paddingRight: padX }}
    >
      <img
        src="/brand/newicon-2x.png"
        alt=""
        aria-hidden="true"
        style={{ height: Math.round(h * 0.86), width: "auto", display: "block" }}
      />
      {showWordmark && (
        <span className="flex flex-col leading-none" style={{ marginLeft: Math.round(h * 0.18) }}>
          <span
            className="text-white font-extrabold"
            style={{
              fontFamily: "'Manrope', 'Inter', sans-serif",
              fontSize: eco,
              letterSpacing: "-0.01em",
              lineHeight: 1,
            }}
          >
            Eco Ready
          </span>
          <span
            className="text-white/95 font-medium"
            style={{
              fontFamily: "'Manrope', 'Inter', sans-serif",
              fontSize: sol,
              letterSpacing: "0.22em",
              lineHeight: 1,
              marginTop: Math.round(h * 0.10),
            }}
          >
            SOLUTIONS, LLC
          </span>
        </span>
      )}
    </span>
  );
}
